import PropTypes from 'prop-types';
import styles from './FJMyLike.module.less';
import FJBlankPanel from '../../../../FJMainPreview/FJBlankPanel/FJBlankPanel';
import FJLocalStore from '../../../../../store/FJLocalStore';
import NoContentIcon from '../../../../../assets/svg/no-content.svg?react';
import FJCommunityMixViewList from '../../../FJCommonComponent/FJCommunityMixViewList/FJCommunityMixViewList';
const FJMyLike = props => {
    const {
        active,
        likedCreationsList,
        getMoreLikedCreationsData,
        likedCreationsPageInfo,
        changeNavBarTabToCommunity,
    } = props;
    const { initLoading, getMoreLoading, hasMore } = likedCreationsPageInfo;
    const _likeNow = () => {
        changeNavBarTabToCommunity();
    };
    const _renderEmpty = () => {
        return (
            <FJBlankPanel
                icon={<NoContentIcon />}
                text={FJLocalStore._('no-liked-creations-yet')}
                textSuffix={<span onClick={_likeNow}>{FJLocalStore._('explore-the-community')}</span>}
            />
        );
    };
    const _renderList = () => {
        return (
            <FJCommunityMixViewList
                className={styles.list}
                list={likedCreationsList}
                getMoreData={getMoreLikedCreationsData}
                initLoading={initLoading}
                getMoreLoading={getMoreLoading}
                hasMore={hasMore}
                active={active}
            />
        );
    };
    if (!active) return null;
    if (initLoading) {
        return <FJCommunityMixViewList className={styles.list} initLoading={true} hasMore={true} />;
    }
    return likedCreationsList.length ? _renderList() : _renderEmpty();
};

FJMyLike.propTypes = {
    active: PropTypes.bool.isRequired,
    likedCreationsList: PropTypes.array.isRequired,
    getMoreLikedCreationsData: PropTypes.func.isRequired,
    likedCreationsPageInfo: PropTypes.object.isRequired,
    changeNavBarTabToCommunity: PropTypes.func.isRequired,
};

export default FJMyLike;
